import './styles.scss';

import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';
import { I18n } from 'react-redux-i18n';

export default class SinglePhotoPhotoSectionCheckoutTitle extends React.Component {
    static propTypes = {
        photo: PropTypes.shape({
            selectedCaption: PropTypes.string,
            user: PropTypes.shape({
                href: PropTypes.string.isRequired,
                username: PropTypes.string.isRequired
            }).isRequired
        }).isRequired
    };
    static defaultProps = {}

    render() {
        const { photo } = this.props;

        let headline, subheadline;
        if (photo.selectedCaption && photo.selectedCaption.length > 150) {
            headline = photo.selectedCaption.substring(0, 50);
            subheadline = photo.selectedCaption.substring(50);
        } else {
            headline = photo.selectedCaption;
        }

        return (
            <div className="single-photo-photo-section-checkout-title">
                <h1 itemProp="name">{headline}{subheadline ? <small>{subheadline}</small> : null}</h1>
                {photo.user ?
                    <h3>
                        {I18n.t('SINGLE_PHOTO.checkout.photoBy')} <Link to={photo.user.href}><strong>{photo.user.username}</strong></Link>
                    </h3>
                    : null}
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/public/single-photo/Photo/components/CheckoutTitle/index.js